import {
  AuditionRequestIcon,
  CalendarIconTwoTone,
  CheckInIcon,
  DashboardIcon,
  OpportunitiesIcon,
  OutlinedUserIcon,
  ProjectsIcon,
  ResumeIcon,
  SelfTapesIcon,
  UpcomingAuditionIcon,
} from '@room-match/shared-ui-components';
import React from 'react';
import { GoLink } from 'react-icons/go';
import { CONFIG } from 'shared/config';

import { ROUTES } from './ROUTES';

interface ISidebarItems {
  name: string;
  icon: React.ReactNode;
  link?: string;
}
export const SIDEBAR_ITEMS: ISidebarItems[] = [
  {
    name: 'Dashboard',
    icon: <DashboardIcon />,
    link: ROUTES.TALENT.DASHBOARD,
  },
  {
    name: 'Auditions',
    icon: <AuditionRequestIcon />,
    link: `${ROUTES.TALENT.AUDITIONS}/audition_request`,
  },
  // {
  //   name: 'Audition Request',
  //   icon: <AuditionRequestIcon />,
  //   link: ROUTES.TALENT.AUDITION_REQUEST,
  // },
  // {
  //   name: 'Attended Auditions',
  //   icon: <AuditionRequestIcon />,
  //   link: ROUTES.TALENT.ATTENDED_AUDITIONS,
  // },
  // {
  //   name: 'Upcoming Auditions',
  //   icon: <UpcomingAuditionIcon />,
  //   link: ROUTES.TALENT.UPCOMING_AUDITIONS,
  // },
  {
    name: 'Self-Tapes',
    icon: <SelfTapesIcon />,
    link: ROUTES.TALENT.SELFTAPES,
  },
  {
    name: 'Check-In',
    icon: <CheckInIcon />,
    link: ROUTES.TALENT.CHECKIN,
  },
  {
    name: 'Opportunities',
    icon: <OpportunitiesIcon />,
    link: ROUTES.TALENT.OPPORTUNITIES,
  },

  {
    name: 'Calendar',
    icon: <CalendarIconTwoTone />,
    link: ROUTES.TALENT.CALENDAR,
  },
  // {
  //   name: 'Representatives',
  //   icon: <OutlinedUserIcon />,
  //   link: ROUTES.TALENT.PROFILES,
  // },
  {
    name: 'Representatives',
    icon: <OutlinedUserIcon />,
    link: ROUTES.TALENT.REPRESENTATIVES,
  },
  {
    name: 'Media',
    icon: <ProjectsIcon />,
    link: `${ROUTES.TALENT.MEDIA}/dashboard`,
  },
  {
    name: 'My Info',
    icon: <ResumeIcon />,
    link: `${ROUTES.TALENT.MYINFO}/general_appearance`,
  },
  { name: 'My Links', icon: <GoLink size={20} />, link: ROUTES.TALENT.MYLINKS },
];
